import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-asessyllabus',
    templateUrl: './asessyllabus.component.html',
    styleUrls: ['./asessyllabus.component.scss']
})
export class AsessyllabusComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
